import { Icon } from 'antd';
import iconShared from 'assets/images/icons/icon-share-15.png';
import classNames from 'classnames/bind';
import React, { Component } from 'react';
import styles from '../index.less';

const cx = classNames.bind(styles);

const getAddonBefore = WrappedComponent =>
  class extends Component {
    renderAddonByState = ({
      sharedToTeams,
      sharedToUsers,
      isActive,
      sharedBy
    }) => (
      <div className={cx('addonBefore')}>
        <Icon
          className="cursor-pointer"
          type={isActive ? 'folder-open' : 'folder'}
          onClick={this.handleIconClick}
        />
        <img
          alt="Shared Folder"
          src={iconShared}
          className="ml-sm mr-sm"
          style={{
            width: '10px',
            opacity:
              !sharedBy &&
              (sharedToUsers.length > 0 || sharedToTeams.length > 0)
                ? 1
                : 0
          }}
        />
      </div>
    );

    render() {
      return (
        <WrappedComponent
          {...this.props}
          addonBefore={this.renderAddonByState(this.props)}
        />
      );
    }
  };

export default getAddonBefore;



// WEBPACK FOOTER //
// ./src/views/ReportListSider/components/getAddonBefore.jsx